// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Theme Name: Hanna Szíve
Author: WEBPRO
Author URI: https://www.web-pro.hu
Requires at least: 6.4
Tested up to: 6.6
Requires PHP: 8.2
Version: 1.0
Text Domain: hsz
*/

.righteous-regular {
  font-family: "Righteous", system-ui;
  font-weight: 400;
  font-style: normal;
}


.cormorant-garamond-light {
  font-family: "Cormorant Garamond", serif;
  font-weight: 300;
  font-style: normal;
}

.cormorant-garamond-regular {
  font-family: "Cormorant Garamond", serif;
  font-weight: 400;
  font-style: normal;
}

.cormorant-garamond-medium {
  font-family: "Cormorant Garamond", serif;
  font-weight: 500;
  font-style: normal;
}

.cormorant-garamond-semibold {
  font-family: "Cormorant Garamond", serif;
  font-weight: 600;
  font-style: normal;
}

.cormorant-garamond-bold {
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  font-style: normal;
}

.cormorant-garamond-light-italic {
  font-family: "Cormorant Garamond", serif;
  font-weight: 300;
  font-style: italic;
}

.cormorant-garamond-regular-italic {
  font-family: "Cormorant Garamond", serif;
  font-weight: 400;
  font-style: italic;
}

.cormorant-garamond-medium-italic {
  font-family: "Cormorant Garamond", serif;
  font-weight: 500;
  font-style: italic;
}

.cormorant-garamond-semibold-italic {
  font-family: "Cormorant Garamond", serif;
  font-weight: 600;
  font-style: italic;
}

.cormorant-garamond-bold-italic {
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  font-style: italic;
}


body, html{
  font-family: "Cormorant Garamond", serif;
  font-optical-sizing: auto;
  font-size: 1.24rem;
  font-weight: 400;
  line-height: 1.4;
  font-style: normal;
  font-variation-settings:
    "wdth" 400;
}

h1, h2, h3, h4, h5, h6{
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  font-style: normal;
}

h1{
  font-size: 2.8rem !important;
}

.content-wrapper{
  line-height: 1.58;
  font-size: 1.08rem;
}

.content-wrapper p {
  margin: 12px 0;
}`, "",{"version":3,"sources":["webpack://./wp-content/themes/hannaszive/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;CASC;;AAED;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB;cACY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/*\nTheme Name: Hanna Szíve\nAuthor: WEBPRO\nAuthor URI: https://www.web-pro.hu\nRequires at least: 6.4\nTested up to: 6.6\nRequires PHP: 8.2\nVersion: 1.0\nText Domain: hsz\n*/\n\n.righteous-regular {\n  font-family: \"Righteous\", system-ui;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n.cormorant-garamond-light {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 300;\n  font-style: normal;\n}\n\n.cormorant-garamond-regular {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.cormorant-garamond-medium {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.cormorant-garamond-semibold {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.cormorant-garamond-bold {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.cormorant-garamond-light-italic {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 300;\n  font-style: italic;\n}\n\n.cormorant-garamond-regular-italic {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.cormorant-garamond-medium-italic {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.cormorant-garamond-semibold-italic {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.cormorant-garamond-bold-italic {\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 700;\n  font-style: italic;\n}\n\n\nbody, html{\n  font-family: \"Cormorant Garamond\", serif;\n  font-optical-sizing: auto;\n  font-size: 1.24rem;\n  font-weight: 400;\n  line-height: 1.4;\n  font-style: normal;\n  font-variation-settings:\n    \"wdth\" 400;\n}\n\nh1, h2, h3, h4, h5, h6{\n  font-family: \"Cormorant Garamond\", serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\nh1{\n  font-size: 2.8rem !important;\n}\n\n.content-wrapper{\n  line-height: 1.58;\n  font-size: 1.08rem;\n}\n\n.content-wrapper p {\n  margin: 12px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
